import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./GetInvolved.css";

const IconDonate = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
    <path d="M12 6v2m0 8v2M9 9.5A2.5 2.5 0 0111.5 7H13a2 2 0 010 4h-2a2 2 0 000 4h1.5A2.5 2.5 0 0115 12.5" />
  </svg>
);

const IconVolunteer = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </svg>
);

const IconPartner = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" />
  </svg>
);

const IconSpread = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="M8.59 13.51l6.83 3.98M15.41 6.51L8.59 10.49" />
  </svg>
);

const ways = [
  {
    Icon: IconDonate,
    title: "Donate",
    desc: "Give once or monthly. Choose a cause or support the general fund. Every rand has a direct impact.",
    action: "Donate Now",
    link: "/donate",
  },
  {
    Icon: IconVolunteer,
    title: "Volunteer",
    desc: "Bring your time, skills, and energy to serve in one of our seven programmes. We welcome all backgrounds.",
    action: "Fill in the form below",
    link: null,
  },
  {
    Icon: IconPartner,
    title: "Partner With Us",
    desc: "Corporate sponsors, NGOs, and community partners — we welcome organisations that share our values.",
    action: "Get in Touch",
    link: "/contact",
  },
  {
    Icon: IconSpread,
    title: "Spread the Word",
    desc: "Share our story. Tell your community about the work we do. Awareness leads to action.",
    action: "Contact Us",
    link: "/contact",
  },
];

function validate(form) {
  const errors = {};
  if (!form.name.trim()) errors.name = "Name is required.";
  if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
    errors.email = "Valid email required.";
  if (!form.phone.trim()) errors.phone = "Phone number is required.";
  if (!form.area) errors.area = "Please select an area of interest.";
  if (!form.availability)
    errors.availability = "Please select your availability.";
  return errors;
}

export default function GetInvolved() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    area: "",
    availability: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (errors[name]) setErrors((er) => ({ ...er, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSubmitted(true);
  };

  return (
    <main>
      <section className="page-hero" aria-label="Get Involved page hero">
        <div
          className="page-hero-bg"
          style={{
            backgroundImage: "url('/images/gallery/eating-children-06.jpg')",
          }}
        />
        <div className="container page-hero-content">
          <span className="eyebrow" style={{ color: "var(--amber-light)" }}>
            Make a Difference
          </span>
          <h1>Get Involved</h1>
          <p>
            There are many ways to support the Food and Nutrition Foundation.
            Choose the one that fits you best.
          </p>
        </div>
      </section>

      {/* WAYS TO HELP */}
      <section className="section ways-section" aria-labelledby="ways-heading">
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">How You Can Help</span>
            <h2 id="ways-heading">Every Action Counts</h2>
            <div className="divider divider-center" />
          </div>
          <div className="ways-grid">
            {ways.map((w, i) => (
              <div className="way-card" key={i}>
                <div className="way-icon">
                  <w.Icon />
                </div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
                {w.link ? (
                  <Link to={w.link} className="btn btn-outline-green btn-sm">
                    {w.action}
                  </Link>
                ) : (
                  <a
                    href="#volunteer-form"
                    className="btn btn-outline-green btn-sm"
                  >
                    {w.action}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VOLUNTEER FORM */}
      <section
        className="section volunteer-form-section"
        id="volunteer-form"
        aria-labelledby="volunteer-form-heading"
      >
        <div className="container">
          <div className="volunteer-form-layout">
            <div className="volunteer-form-intro">
              <span className="eyebrow">Volunteer</span>
              <h2 id="volunteer-form-heading">Join Our Volunteer Community</h2>
              <div className="divider" />
              <p>
                Our volunteers are the lifeblood of the Food and Nutrition
                Foundation. Whether you have an hour a week or a full day, there
                is a role for you in our programmes.
              </p>
              <p>
                We welcome people with skills in cooking, teaching,
                administration, healthcare, communications, photography,
                fundraising, and community outreach.
              </p>
              <div className="volunteer-quote">
                <blockquote>
                  "Every volunteer who shows up in Kamanga Compound sends a
                  message to the community: you are not forgotten."
                </blockquote>
                <p className="volunteer-quote-attr">
                  — Mrs. Charity Katotobwe Sikazwe, Founder
                </p>
              </div>
            </div>

            <div className="volunteer-form-wrap">
              {submitted ? (
                <div className="form-success">
                  <div className="form-success-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <h3>Thank You!</h3>
                  <p>
                    We've received your volunteer enquiry. A member of our team
                    will be in touch within 5 business days.
                  </p>
                  <Link
                    to="/donate"
                    className="btn btn-primary"
                    style={{ marginTop: "1rem" }}
                  >
                    Support Us With a Donation
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="grid-2">
                    <div className="form-group">
                      <label htmlFor="v-name">Full Name *</label>
                      <input
                        id="v-name"
                        name="name"
                        type="text"
                        className={`form-control${errors.name ? " error" : ""}`}
                        value={form.name}
                        onChange={handleChange}
                        autoComplete="name"
                      />
                      {errors.name && (
                        <p className="error-msg" role="alert">
                          {errors.name}
                        </p>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="v-email">Email Address *</label>
                      <input
                        id="v-email"
                        name="email"
                        type="email"
                        className={`form-control${errors.email ? " error" : ""}`}
                        value={form.email}
                        onChange={handleChange}
                        autoComplete="email"
                      />
                      {errors.email && (
                        <p className="error-msg" role="alert">
                          {errors.email}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="v-phone">Phone Number *</label>
                    <input
                      id="v-phone"
                      name="phone"
                      type="tel"
                      className={`form-control${errors.phone ? " error" : ""}`}
                      value={form.phone}
                      onChange={handleChange}
                      autoComplete="tel"
                    />
                    {errors.phone && (
                      <p className="error-msg" role="alert">
                        {errors.phone}
                      </p>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="v-area">Area of Interest *</label>
                    <select
                      id="v-area"
                      name="area"
                      className={`form-control${errors.area ? " error" : ""}`}
                      value={form.area}
                      onChange={handleChange}
                    >
                      <option value="">Select a programme...</option>
                      <option value="feeding">Feeding Programme</option>
                      <option value="nutrition">Nutrition Education</option>
                      <option value="school">
                        School Sponsorship &amp; Literacy
                      </option>
                      <option value="homecare">Home-Based Care</option>
                      <option value="skills">
                        Skills Training &amp; Development
                      </option>
                      <option value="ecd">Early Childhood Development</option>
                      <option value="ovc">
                        Orphans &amp; Vulnerable Children
                      </option>
                      <option value="general">General / Any Programme</option>
                    </select>
                    {errors.area && (
                      <p className="error-msg" role="alert">
                        {errors.area}
                      </p>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="v-availability">Availability *</label>
                    <select
                      id="v-availability"
                      name="availability"
                      className={`form-control${errors.availability ? " error" : ""}`}
                      value={form.availability}
                      onChange={handleChange}
                    >
                      <option value="">Select your availability...</option>
                      <option value="weekday-mornings">Weekday mornings</option>
                      <option value="weekday-afternoons">
                        Weekday afternoons
                      </option>
                      <option value="weekends">Weekends</option>
                      <option value="flexible">Flexible / Remote only</option>
                      <option value="once-off">Once-off project</option>
                    </select>
                    {errors.availability && (
                      <p className="error-msg" role="alert">
                        {errors.availability}
                      </p>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="v-message">
                      Tell Us About Yourself (Optional)
                    </label>
                    <textarea
                      id="v-message"
                      name="message"
                      className="form-control"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Your skills, experience, or anything else you'd like us to know..."
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: "100%", justifyContent: "center" }}
                  >
                    Submit Volunteer Enquiry
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="cta-band" aria-label="Donate CTA">
        <div className="container cta-band-inner">
          <div>
            <h2>Can't Volunteer? Donate Instead.</h2>
            <p>Every rand goes directly to the people who need it most.</p>
          </div>
          <div className="cta-band-actions">
            <Link to="/donate" className="btn btn-primary btn-lg">
              Donate Now
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
